/* eslint-disable react/prop-types */

import moment from "moment";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";

function renderLocations(ids = [], locationsMap = {}, len = 3) {
  const locations = ids.filter((id) => locationsMap[id]).map((id) => locationsMap[id].name);
  let value = locations.slice(0, len).join(", ");
  if (locations.length > len) {
    value += `, +${locations.length - len}`;
  }
  return value;
}

export default function tableConfig() {
  return {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Email", accessor: "email", align: "center" },
      { Header: "Username", accessor: "username", align: "center" },
      { Header: "Role", accessor: "role", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Pay Group", accessor: "payGroups", align: "center" },
      { Header: "Created At", accessor: "createdAt", align: "center" },
      { Header: "Actions", accessor: "action", align: "center" },
    ],
    getRows: (data, setUserToEdit, payGroupData) =>
      data.map((d) => ({
        name: `${d.firstName} ${d.lastName}`,
        email: d.email,
        username: d.username,
        role: d.role,
        payGroups:
          d.permissions && d.permissions.payGroups
            ? renderLocations(d.permissions.payGroups, payGroupData, 2)
            : "",
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={d.status === "1" ? "Active" : "Inactivte"}
              color={d.status === "1" ? "success" : "error"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        createdAt: d.createdAt ? moment(d.createdAt).locale("en").format("LLL") : "Never",
        action: (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => setUserToEdit(d)}
          >
            <Icon fontSize="small">edit</Icon>
          </IconButton>
        ),
      })),
  };
}
